"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["GBP"] = "GBP";
    Currency["EUR"] = "EUR";
})(Currency = exports.Currency || (exports.Currency = {}));
const currencySupport = {
    // we are moving from UK to GB for our country code, as UK was initially
    // used but is not the correct two-letter code (and thus causes some issues).
    // include both until things are settled!
    UK: {
        symbol: "£",
        code: Currency.GBP,
        vat: 0.2,
    },
    GB: {
        symbol: "£",
        code: Currency.GBP,
        vat: 0.2,
    },
    IE: {
        symbol: "€",
        code: Currency.EUR,
        vat: 0.23,
    },
};
exports.default = currencySupport;
